import {white, grey200} from 'material-ui/styles/colors';

const styles = {
    emptySpace: {
        marginBottom: 20
    },
    avatar: {
        display: 'inline-block',
        position: 'relative',
        top: -20,
        borderRadius: '10%',
        backgroundColor: white,
        boxShadow: 'rgba(0, 0, 0, 0.22) 0px 1px 6px, rgba(0, 0, 0, 0.22) 0px 1px 4px'
    },
    box: {
        marginTop: 40,
        paddingRight: 20,
        paddingBottom: 20,
        paddingLeft: 20,
        color: white
    },
    header: {
        float: 'right',
        display: 'inline-block',
        position: 'relative',
        top: 0,
        textAlign: 'right',
        color: white
    },
    headerspan: {
        float: 'right',
        display: 'inline-block',
        position: 'relative',
        top: -20,
        textAlign: 'right',
        fontSize: 13,
        width: '100%',
        color: grey200,
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/ModuleBlock.css.js